import PublicApiModel from './globals/PublicApiModel';

export default class RefreshTokenModel extends PublicApiModel {
  static get path() {
    return '/backend/token/refresh';
  }
}
